import { callApi } from 'utils/api'
import {createFastAccess} from './fast_access'


export const getSysCompanyInfo = (sys_company_id) => {
	return async (dispatch, getState) => {
		const state = getState()

		try {
			const res = await callApi(`/sys_company/get_sys_company_info/${sys_company_id}`, {
			})

      if(res.status == 200){
        dispatch({ type: 'LOAD_COMAPANY_INFO', payload: res.body })

        //In case the modal for quick access was filled before scan/type a code
        dispatch(createFastAccess({sys_company_id}))
      }
			return res.body
		} catch (error) {
        throw error
    }
	}
}

export const getFoodStallInfo = (sys_company_id, product_id) => {
  return async (dispatch, getState) => {
    const state = getState();
    try {
      const res = await callApi(`/sys_company/get_sys_company_info/${sys_company_id}`,{

	  });

      if (res.status == 200) {
        const modifiedBody = {
          ...res.body, // Copiar las propiedades originales
          productId: product_id ? product_id : 0, // Agregar nuevas propiedades
        };
        dispatch({ type: "LOAD_FODD_STALL_INFO", payload: modifiedBody });
      }
	  
      return res.body;
    } catch (error) {
      throw error;
    }
  };
};

export const loadStripeKeys = (sysCompanyId) => {
  return async (dispatch, getState) => {
    const res = await callApi(`/sys_company/get_sys_company_info/${sysCompanyId}`, {
      method: "GET",
      errorMessage: "Ha ocurrido un error al procesar la compra. Favor de contactar el administrador del sistema.",
    });

    if (res.status === 200) {
      dispatch({
        type: "SET_SYS_COMPANY_STRIPE_KEYS",
        payload: {
          stripe_public_key: res.body.stripe_public_key,
          stripe_secret_key: res.body.stripe_secret_key, // Si lo necesitas
        },
      });

      return {
        stripe_public_key: res.body.stripe_public_key,
        stripe_secret_key: res.body.stripe_secret_key, // Si lo necesitas
      };
    }
  }
};

export const authenticateClient = (functionParam=()=>{}) => {
  return async (dispatch, getState) => {
    const state = getState()
    const isClientAuthenticated = !!state.app?.client
    if(isClientAuthenticated){
      functionParam()
    }
    else{
      dispatch({type: 'SET_LOGIN_MODAL', payload: true})
    }
  }
}

export default {
	getSysCompanyInfo,
}